export function applyUiSync(uiSync, handlers = {}) {
  const { handleChange, resetToDefaults } = handlers;
  if (!Array.isArray(uiSync)) return;
  uiSync.forEach((item) => {
    if (!item || !item.action) return;
    if(item.action==='navigate' && typeof handlers.navigate==='function' && /^\/admin\/(?:roi(?:\/create|\/[a-z0-9-]{36}(?:\/(?:calculation-logic|custom-variable))?)?|roi-agent|roi-analytics)$/.test(item.path||''))handlers.navigate(item.path);
    if (item.action === "set_field" && typeof handleChange === "function") {
      const uuid = item.uuid || item.id;
      if (!uuid) return;
      handleChange(uuid, { target: { value: String(item.value ?? "") } });
    }
    if (item.action === "reset_ui" && typeof resetToDefaults === "function") {
      resetToDefaults();
    }
  });
}

export function collectFieldStateFromGlobal(roiActionArrRef) {
  const arr = roiActionArrRef?.current || {};
  const out = {};
  Object.keys(arr).forEach((uuid) => {
    if (arr[uuid]?.value !== undefined) {
      out[uuid] = arr[uuid].value;
    }
  });
  return out;
}
